import * as React from "react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isReactComponent = (component: any): boolean =>
  React.isValidElement(component) && typeof component.type === "function";

interface IProps {
  activeCard?: string | string[];
  uncontrolled?: boolean;
  // @ts-expect-error TS(7010): 'onCardOpen', which lacks return-type annotation, ... Remove this comment to see the full error message
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCardOpen?(cardName: any);
  children: React.ReactNode;
}
interface IState {
  openedCards: string[];
}

/**
 * CardWrapper is a container provided accordion control for Cards
 * @param activeCard provide current open card(s)
 * @param uncontrolled allow to set method of component control for inner state
 * @param onCardOpen executed function if card will be open
 */
export class CardWrapper extends React.PureComponent<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let openedCards: any = [];
    if (Array.isArray(props.activeCard)) {
      openedCards = [...openedCards, ...props.activeCard];
    } else if (props.activeCard) {
      openedCards = [...openedCards, props.activeCard];
    }

    this.state = {
      openedCards,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleCardClicked = (cardName: any) => () => {
    if (!this.props.uncontrolled) {
      return this.props.onCardOpen && this.props.onCardOpen(cardName);
    }

    if (!this.isCollapsed(cardName)) {
      return this.setState({ openedCards: [] });
    }

    return this.setState({ openedCards: [cardName] }, () => this.props.onCardOpen && this.props.onCardOpen(cardName));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  isCollapsed = (cardName: any) => {
    if (this.props.uncontrolled) {
      return this.state.openedCards.some(el => el === cardName);
    }

    return Array.isArray(this.props.activeCard)
      ? !this.props.activeCard.includes(cardName)
      : cardName !== this.props.activeCard;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  injectProps = (child: any) =>
    isReactComponent(child)
      ? React.cloneElement(child, {
          handleCardOpen: this.handleCardClicked(child.props.id),
          isCardCollapsed: this.isCollapsed(child.props.id),
        })
      : child;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childrenWithProps = React.Children.map(this.props.children, (child: any) =>
      child ? this.injectProps(child) : null
    );

    return <>{childrenWithProps}</>;
  }
}
